import React, { useState, useEffect } from 'react';
import './Timer.style.css';

// format="HMS" → 시:분:초 (기본값)
// format="DH" → 일 시 분 (하루 이상 남았을 때 사용하는 포맷)
const Timer = ({ start, end, style = {}, format = 'HMS' }) => {
  const [timer, setTimer] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  const calculateTime = () => {
    const nowTime = new Date();
    const startTime = new Date(start);
    const endTime = new Date(end);

    const targetTime = nowTime < startTime ? startTime : endTime;

    const totalSeconds = Math.max(0, Math.floor((targetTime - nowTime) / 1000));

    // 포맷이 'DH'이면 '일 시 분' 형식으로 나누기
    if (format === 'DH') {
      const days = Math.floor(totalSeconds / 86400);
      const remainingAfterDays = totalSeconds % 86400;

      const hours = Math.floor(remainingAfterDays / 3600);
      const remainingAfterHours = remainingAfterDays % 3600;

      const minutes = Math.floor(remainingAfterHours / 60);

      return { days, hours, minutes };
    }

    // 포맷이 'HMS'일 경우 시:분:초 형식 표시
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return { days: 0, hours, minutes, seconds };
  };

  useEffect(() => {
    setTimer(calculateTime());
    const interval = setInterval(() => {
      setTimer(calculateTime());
    }, 1000);

    return () => clearInterval(interval);
  }, [start, end, format]);

  const formatTime = (time) => String(time).padStart(2, '0');

  // format이 'DH'일 경우: "n일 n시간 n분" 형식으로 출력
  const renderDaysFormat = () => (
    <ul className="timer_layout">
      <li className="timer_item days" style={{ ...style }}>
        {formatTime(timer.days)}
      </li>
      <p className="DH">일</p>
      <li className="timer_item hours" style={{ ...style }}>
        {formatTime(timer.hours)}
      </li>
      <p className="DH">시간</p>
      <li className="timer_item minutes" style={{ ...style }}>
        {formatTime(timer.minutes)}
      </li>
      <p className="DH minutes">분</p>
    </ul>
  );

  // format이 'HMS'일 경우: "시:분:초" 형식으로 출력(기본값)
  const renderHMSFormat = () => (
    <ul className="timer_layout">
      <li className="timer_item hours" style={{ ...style }}>
        {formatTime(timer.hours)}
      </li>
      <li className="timer_separator" style={{ ...style }}>
        :
      </li>
      <li className="timer_item minutes" style={{ ...style }}>
        {formatTime(timer.minutes)}
      </li>
      <li className="timer_separator" style={{ ...style }}>
        :
      </li>
      <li className="timer_item seconds" style={{ ...style }}>
        {formatTime(timer.seconds)}
      </li>
    </ul>
  );

  // format 값에 따라 출력 형식 분기
  return format === 'DH' ? renderDaysFormat() : renderHMSFormat();
};

export default Timer;
